import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

export const ProblemsSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#004534] mb-6">
            Por qué elegirnos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transformamos los problemas más comunes en soluciones efectivas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {mockData.problems.map((item, index) => (
            <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-none bg-white">
              <CardContent className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex-1">
                    <div className="text-red-600 font-semibold text-lg mb-2 flex items-center">
                      <div className="w-3 h-3 bg-red-500 rounded-full mr-3"></div>
                      Problema
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {item.problem}
                    </h3>
                  </div>
                  <ArrowRight className="h-8 w-8 text-[#f97316] mx-4 group-hover:scale-110 transition-transform" />
                  <div className="flex-1">
                    <div className="text-[#16a34a] font-semibold text-lg mb-2 flex items-center">
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Solución
                    </div>
                    <h3 className="text-xl font-bold text-[#004534] mb-2">
                      {item.solution}
                    </h3>
                  </div>
                </div>
                <div className="border-t pt-4">
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Nuestra Garantía de Calidad section removed as requested */}
      </div>
    </section>
  );
};